
import React from 'react';
import HeroSection from '@/components/home/HeroSection';
import ServicesSection from '@/components/home/ServicesSection';
import AboutPreview from '@/components/home/AboutPreview';
import CTASection from '@/components/home/CTASection';
import PageWrapper from '@/components/utils/PageWrapper';
import AnimatedElement from '@/components/utils/AnimatedElement';

const Index = () => {
  return (
    <PageWrapper>
      <AnimatedElement animation="fadeIn" duration={0.5} delay={0.05} threshold={0.01}>
        <HeroSection />
      </AnimatedElement>
      
      <AnimatedElement animation="fadeIn" duration={0.5} delay={0.05} threshold={0.01}>
        <ServicesSection />
      </AnimatedElement>
      
      <AnimatedElement animation="fadeIn" duration={0.5} delay={0.05} threshold={0.01}>
        <AboutPreview />
      </AnimatedElement>
      
      <AnimatedElement animation="fadeIn" duration={0.5} delay={0.05} threshold={0.01}>
        <CTASection />
      </AnimatedElement>
    </PageWrapper>
  );
};

export default Index;
